import { twMerge } from "tailwind-merge";

export function StatusTabs({ statusOptions, value, onChange }: { statusOptions: any[], value: string, onChange: (value: string) => void }) {
    return (
        <div className="overflow-x-auto">
            <div className="flex gap-2 relative pb-2 w-max min-w-full">
                {statusOptions.map((tab) => (
                    <button
                        key={tab.value}
                        onClick={() => onChange(tab.value)}
                        className={`report-tab-button relative z-[5] flex shrink-0 items-center gap-1 whitespace-nowrap text-[clamp(8px,1.2vw,12px)] p-2.5 ${value === tab.value
                            ? "text-headerPrimary selected-report-tab-button font-semibold"
                            : "text-text-primary hover:text-text-primary/70 font-normal"
                            }`}
                    >
                        {tab.label}
                        <div
                            className={twMerge("relative font-bold text-[clamp(7px,1.2vw,9px)] leading-[16px] w-[clamp(16px,1.2vw,20px)] h-[clamp(16px,1.2vw,20px)] rounded-full flex items-center justify-center ml-1", value === tab.value ? "text-headerPrimary" : "text-gray-403")}
                        >
                            <div className={twMerge("absolute top-0 left-0 w-full h-full bg-[#F3F4F6] rounded-full", value === tab.value ? "bg-headerPrimary opacity-30" : "")} />
                            <span className="z-[1]">{tab.count}</span>
                        </div>
                    </button>
                ))}
                <div className="absolute bottom-1.5 left-0 w-full h-[1px] bg-gray-402 opacity-50" />
            </div>
        </div>
    );
}